import { put, race, take, takeLatest } from 'redux-saga/effects';

import { actions as formActions } from '../../entities/resources/forms';
import { actions as taskActions } from '../../entities/resources/tasks';
import { actions } from './actions';

const formUpdateSuccessType = formActions.updateRequestSuccess.toString();
const formUpdateFailureType = formActions.updateRequestFailure.toString();
const taskShowSuccessType = taskActions.showRequestSuccess.toString();
const taskShowFailureType = taskActions.showRequestFailure.toString();

/**
 * A function that listens to form updates for a specified form
 * it finds a form update it will remove the task from in progress
 * and then dispatch a new request to update the task from the API.
 *
 * This way if there is a task solved by submitting the form, we get
 * the updated data from the API.
 */
function* refreshAfterFormUpdate({ payload }) {
  const { taskId, formId } = payload;

  const { success } = yield race({
    success: take(
      (action) =>
        action.type === formUpdateSuccessType &&
        action.payload?.args?.id === formId
    ),
    failure: take(
      (action) =>
        action.type === formUpdateFailureType &&
        action.payload?.args?.id === formId
    ),
  });

  yield put(actions.removeFromInProgress(taskId));

  if (!success) {
    return;
  }

  yield put(taskActions.showRequestBegin(taskId));

  yield race({
    success: take(
      (action) =>
        action.type === taskShowSuccessType &&
        action.payload?.result?.tasks?.includes(taskId)
    ),
    failure: take(
      (action) =>
        action.type === taskShowFailureType &&
        (action.payload?.args?.id ?? action.payload?.args ?? '') === taskId
    ),
  });

}

function* watchRefreshAfterFormUpdate() {
  yield takeLatest(actions.refreshAfterFormUpdate, refreshAfterFormUpdate);
}

export const sagas = [watchRefreshAfterFormUpdate];
